import { Component, DestroyRef, inject, OnInit, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { StoryService } from 'app/my-history/story/story.service';
import { TextService } from 'app/shared/text.service';
import { MenuItemComponent } from '../menu-item/menu-item.component';
import { routePath } from 'app/shared/app.config';
import { Router } from '@angular/router';
import { BadgeComponent } from 'app/shared/badge/badge.component';
import { IconComponent } from 'app/shared/icon/icon.component';
import { DatePipe } from "@angular/common";
import { FriendsService } from "app/friends/service/friends.service";
import { IFriendsResponse } from "app/friends/model/friends.model";

@Component({
  selector: 'app-side-menu',
  standalone: true,
  imports: [MatSidenavModule, MenuItemComponent, BadgeComponent, IconComponent, DatePipe],
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent implements OnInit {
  router = inject(Router);

  sidenav = viewChild.required<MatSidenav>('sidenav');
  text = inject(TextService);
  story = inject(StoryService);
  friendsService = inject(FriendsService);
  destroyRef = inject(DestroyRef);
  storiesTotal = this.story.storiesTotal;
  friendsTotal = this.friendsService.friendsTotal;

  today = new Date();
  menuItems = [
    {
      iconName: 'book-open',
      title: this.text.get('menu_my_stories'),
      count: this.storiesTotal,
      routerLink: `${routePath.myHistory}/${routePath.stories}`,
    },
    {
      iconName: 'user-square',
      title: this.text.get('menu_friends'),
      count: this.friendsTotal,
      routerLink: `${routePath.friends}`,
    },
    {
      iconName: 'dashboard',
      title: this.text.get('menu_dashboard'),
    },
    {
      iconName: 'settings',
      title: this.text.get('menu_setings'),
    },
    {
      iconName: 'image',
      title: this.text.get('menu_replay_tour'),
    },
    {
      iconName: 'chat-info',
      title: this.text.get('menu_get_in_touch'),
      routerLink: `${routePath.contactUs}`,
    },
    {
      iconName: 'faq',
      title: this.text.get('menu_faqs'),
    },
    {
      iconName: 'file',
      title: this.text.get('menu_privacy'),
      routerLink: `${routePath.privacyPolicy}`,
    },
    {
      iconName: 'file',
      title: this.text.get('terms'),
      routerLink: `${routePath.termsConditions}`,
    },
  ];

  ngOnInit(): void {
    this.story.getStoriesTotal().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
    this.friendsService.getFriends().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((friends: IFriendsResponse) => {
        if (friends.total) {
          this.friendsService.setFriendsTotal(friends.total);
        }
    });
  }

  onItemClick(item: any) {
    this.router.navigate([`/${item.routerLink}`]);
    this.sidenav().close()
  }
}
